export const getInitialState = () => ({
  newsletters: [],
  selectedOptionsIds: [],
  isWidgetLoading: true,
  isUpdating: false,
  error: undefined,
});
